import { render, staticRenderFns } from "./inventory_edit.vue?vue&type=template&id=1d07dd94&scoped=true"
import script from "./inventory_edit.vue?vue&type=script&lang=js"
export * from "./inventory_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d07dd94",
  null
  
)

export default component.exports